import axios from 'axios';
import { JwtAxios } from '@/packaging';

/**
 * 비회원 결제링크(/pay/addon/:idx) 전용 API 서버.
 * 링크가 어느 host 에서 열리든 결제·주문 저장·KCP 결과통보는 이 서버 한 곳에서 처리한다.
 */
export const GUEST_PAY_API_URL = 'https://api.cospia.net/api';

/** 로그인 토큰 없이 GUEST_PAY_API_URL 로 요청한다. (401 이어도 로그아웃 처리하지 않음) */
function guestRequest(method, path, body) {
  return axios({
    method,
    url: GUEST_PAY_API_URL + path,
    data: body,
    headers: body ? { 'Content-Type': 'application/json;charset=utf-8' } : {},
    responseType: 'json'
  })
    .then(response => response.data)
    .catch(error => (error.response ? error.response.data : false));
}

export const addonAPI = {
  /** 판매중인 부가서비스 상품목록 (host별 노출) */
  GetSaleAddonProductList: async host => {
    const res = await JwtAxios.get(
      `/AddonProduct/GetSaleAddonProductList?host=${encodeURIComponent(host || '')}`
    );
    return res;
  },
  /** 부가서비스 상품 상세 (옵션 포함) */
  GetAddonProductDetail: async idx => {
    const res = await JwtAxios.get(`/AddonProduct/GetAddonProductDetail?idx=${idx}`);
    return res;
  },
  /** 주문 생성. 금액은 서버가 다시 계산한다. */
  CreateAddonOrder: async body => {
    const res = await JwtAxios.post('/AddonPayment/CreateAddonOrder', body);
    return res;
  },
  /** 마일리지 결제 확정 */
  PayAddonByMileage: async orderId => {
    const res = await JwtAxios.post('/AddonPayment/PayAddonByMileage', { order_id: orderId });
    return res;
  },
  /** 내 부가서비스 주문내역 */
  GetMyAddonOrderList: async (page = 1, row = 20) => {
    const res = await JwtAxios.get(`/AddonPayment/GetMyAddonOrderList?page=${page}&row=${row}`);
    return res;
  },
  /** [비회원] 결제링크 상품 정보 (로그인 불필요) */
  GetGuestProduct: async idx => {
    const res = await guestRequest('GET', `/AddonPayment/GetGuestProduct?idx=${encodeURIComponent(idx)}`);
    return res;
  },
  /** [비회원] 결제링크 주문 생성. 카드(KCP)만 받는다. */
  CreateGuestOrder: async body => {
    const res = await guestRequest('POST', '/AddonPayment/CreateGuestOrder', body);
    return res;
  },
  /** [비회원] 모바일 KCP 결제창 거래등록 */
  GuestKcpTradeReg: async body => {
    const res = await guestRequest('POST', '/AddonPayment/GuestKcpTradeReg', body);
    return res;
  },
  /** [비회원] KCP 결제창 설정 (사이트코드/테스트 여부) */
  GetGuestPgConfig: async () => {
    const res = await guestRequest('GET', '/AddonPayment/GetGuestPgConfig');
    return res;
  },
  /** [비회원] 결제 결과 확인 */
  GetGuestOrderStatus: async orderId => {
    const res = await guestRequest('GET', `/AddonPayment/GetGuestOrderStatus?orderId=${encodeURIComponent(orderId || '')}`);
    return res;
  },
  /** 관리자가 지정한 PG(이니시스/KCP) 설정 */
  GetPgConfig: async () => {
    const res = await JwtAxios.get('/PaymentSetting/GetPgConfig');
    return res;
  }
};
